import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from './toastr.service';
import { ErrorService } from './error.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private toastrService: ToastrService, public errorService: ErrorService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse) {
          let modalStateErrors = '';

          if (error.status === 401) {
            console.log(error.statusText);
            return throwError(error.statusText);
          }

          const applicationError = error.headers.get('Application-Error');
          if (applicationError) {
            console.log(applicationError);
            return throwError(applicationError);
          }
          // const serverError = error.error;
          // let modalStateErrors = '';
          // if (serverError && typeof serverError === 'object') {
          //     for (const key in serverError) {
          //         if (serverError[key] && key === 'title') {
          //             modalStateErrors += serverError[key] + '\n';
          //         }
          //     }
          // }

          const serverError = error.error;
          let modalStateErrorsTitle;
          modalStateErrorsTitle = serverError.title;

          if (
            serverError.errors &&
            typeof serverError.errors === 'object' &&
            serverError.hasOwnProperty('errors')
          ) {

          }

          console.log(modalStateErrors || serverError);
          return throwError(modalStateErrors || serverError || 'Server Error');
        }
      })
    );
  }
}

export const ErrorInterceptorProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: ErrorInterceptor,
  multi: true,
};
